import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JgPhysicalInspCfg } from '../models/jg/jg-physical-insp-cfg.model';
import { GlobalService } from '../providers/global.service';
import { FileResponse } from '../providers/request/file-response.model';
import { RequestService } from '../providers/request/request.service';
import { JgVisualInspCfg } from '../models/jg/jg-visual-insp-cfg.model';

@Injectable({
  providedIn: 'root',
})
export class JgVisualInspCfgService extends RequestService<JgVisualInspCfg> {
  static PATH = '/jg/visual/insp/cfg';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgVisualInspCfgService.PATH, globalService.debugUrl);
  }

  upload(file: File, projectId: number, stage: number) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('projectId', projectId.toString());
    formData.append('stage', stage.toString());
    return this.httpClient.post<FileResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${JgVisualInspCfgService.PATH}/upload`,
      formData,
    );
  }
}
